export function getDisplayName(
  obj: { display_name?: string | null; tennisrecord_name?: string | null; name: string } | null | undefined
): string {
  if (!obj) return 'Unknown';
  return obj.display_name || obj.tennisrecord_name || obj.name;
}
